import PropTypes from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { themeGet } from 'ravenjs';

import { DEFAULT_BRANDING } from 'constants/branding';

const NavLogoStyled = styled.div`
    max-width: 150px;
    padding: 14.5px 0;
    /**
     * The image that is rendered inside the NavLogo component
     */
   
    img {
        height: 20px;
        max-width: 97px;
    }
    /**
     * Add all of the remaining styles from theme
     */
    ${themeGet('NavLogo.styles')};
`;

const NavLogo = ({ theme }) => {
    // Extract the `alt` and `src` from the theme.
    const { alt, src } = themeGet('NavLogo')({ theme });
    // Display the default Mineral logo if one is not present.
    if (!src) {
        return (
            <NavLogoStyled>
                <img src={DEFAULT_BRANDING.logoUrl} alt={DEFAULT_BRANDING.partnerName} />
            </NavLogoStyled>
        );
    }
    // Otherwise, build the logo.
    return (
        <NavLogoStyled>
            <img src={src} alt={alt} />
        </NavLogoStyled>
    );
};

NavLogo.propTypes = {
    theme: PropTypes.object.isRequired
};

NavLogo.defaultProps = {};

export default withTheme(NavLogo);
